export class SnackMessage {

  constructor(public type: string,
              public message: string) {
  }

}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/shared/snack-messages/snack-message.model.ts